import { render } from "./advice-list.vue?vue&type=template&id=91a98f42&scoped=true"
import script from "./advice-list.vue?vue&type=script&lang=js"
export * from "./advice-list.vue?vue&type=script&lang=js"

import "./advice-list.vue?vue&type=style&index=0&id=91a98f42&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a98f42"]])

export default __exports__